import React, { useState,useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { EditTwoTone } from '@ant-design/icons';
import { Input,Pagination,Card } from 'antd';
import { app } from '../../config';
import { getTokenfromUserObj } from '../../utils/getTokenfromObj';
import NoRecordFound from '../../components/common/NoRecordFound';

const Roles = () => {
  const {Search}=Input
  const {t}=useTranslation(["common"])
  const [editbtn, setEditBtn] = useState('none');
  const [fetchedRoles, setFetchedRoles] = useState([]);
  const [search,setSearch]=useState('');
  const [searchShow,setSearchShow]=useState(false);
  const [pagesCount, setPagesCount] = useState(0);
  const [renderList,setRenderList]=useState([]);
  const [current, setCurrent] = useState(1);
  const [tableShow,setTableShow]=useState(true);
  const [err,setErr]=useState('');
  let navigate=useNavigate();
  const editRole = (e) => {
    localStorage.setItem('roleId', JSON.stringify({roleId:e.roleId,roleName:e.name,roleType:e.roleType,isActive:e.isActive}));
    navigate('/role/edit', { replace: true });
  };
  const token=getTokenfromUserObj();
  console.log(token);
  console.log("Roles");
  useEffect(() => {
    const fetchRoles=async()=>{
      const user = JSON.parse(localStorage.getItem('user'));
      if (user.userType === 'A') setEditBtn('block');
      const roleResp=await axios.get(`${app.URL}/role/viewrole`,{headers:{auth:token}})
      console.log(roleResp);
      roleResp.data?setFetchedRoles(roleResp.data.data):" ";
      roleResp.data?setPagesCount(roleResp.data.data.length):" ";
      roleResp.data?setRenderList((roleResp.data.data).slice(0,10)):" ";
    }  
    fetchRoles();  

    }, []);
  const handleSearch=async()=>{
      try{
          const result=search?await axios.get(`${app.URL}/user/search/${search}`):[];
          searchedUser=result.data;
         }
         catch(e){
           console.log("Error");
         if(e.message)setErr(e.response.data.message);
         setTableShow(false);
         }
         
         console.log(searchedUser)
         if(searchedUser){
           setSearchShow(true);
           setRenderList(searchedUser)
         }
         console.log(searchedUser);
  }
  const onSearch = async (value) => {
    console.log(value);
    try{
      const result=await axios.get(`${app.URL}/role/search/${value}`,{headers:{auth:token}});
      console.log(result);
       let searchedRole=result.data.data;
       console.log(searchedRole);
       setRenderList(searchedRole);
       setPagesCount(searchedRole.length);
     }
     catch(e){
       console.log("Error");
       console.log(e);
    //  if(e.message)setErr(e.response.data.message);
     setTableShow(false);
     }
  }
  const onChange = async(page,pageSize) => {
    console.log(page);
    setCurrent(page);
    if(!page)page=1;
    let limit=pageSize;
    let reqObj={
      limit,
      offset:limit*(page-1)
    }
    setRenderList(fetchedRoles.slice(reqObj.offset, reqObj.offset + limit));

  };
  const handleSearchChange=(e)=>{
      if(!e.target.value){
        setRenderList(fetchedRoles.slice(0,10))
          setPagesCount(fetchedRoles.length);};
  }
  const addRole=()=>{
    navigate('/userperm/view',{replace:true});


  }
  console.log(renderList)
 return (

<div className=''>
  <div className='ml-3 col-lg-12 col-md-12 col-sm-12 '>
  <div className='row mt-2'>
    <div className="col-lg-6 col-md-10 col-sm-10 fs-3 fw-bold">
    {t('Role & Permission Management')}
    </div>

    </div>
    <div className='row text-right'>
    <div className="col-lg-5 col-md-5 col-sm-5 mt-4">
    <Search
      className='search'
      placeholder='Search by Role Name'
      onChange={handleSearchChange}
      onSearch={onSearch}
      style={{
        width: 300,
      }}
    />
    </div>
    <div className="col-lg-2 col-md-2 col-sm-2 mt-4">
    <button class="btn btn-primary button" onClick={addRole}>Add Role</button>  
    </div>  
    </div>

  <div className='col-lg-7 col-md-12 col-sm-12 '>
      <div class=' styled-table '>
         <table class='table text-black' >
           <thead class='thead-light'>
             <tr>
                             <th>{t("Role Name")}</th>
                             <th>{t("Role Type")}</th>
                             <th>{t("Status")}</th>
                             <th> </th>
             </tr>
           </thead>
           <tbody >

             {renderList
               ? renderList.map((output) => (

                   <tr className='row-hover' onClick={() => editRole(output)}>
                     <td style={{width:"300px"}} >{output.name?output.name :"null"}</td>
                     <td style={{width:"200px"}}>{output.roleType==="org"?"Organization":"Admin"}</td>
                     <td style={{width:"200px"}}>{output.isActive===1?"Active":"Inactive"}</td>
                     <td>
                     <EditTwoTone displayName="edit" twoToneColor="blue" style={{fontSize:"20px"}} onClick={() => editRole(output)} />
                     </td>
                   </tr>
                 ))
               : ' '}
           </tbody>
         </table>
         {renderList&&renderList.length == 0?<NoRecordFound/>:" "}
       </div>     
  </div>
  <Pagination style={{marginTop:"20px"}} onChange={onChange} defaultCurrent={current} pageSize={10} total={pagesCount} />
  </div>
  {/* </div>  
</div> */}
</div>
    
     
  );
};

export default Roles;
